import { isAppTypeIframe } from "../getAppType";
import { useDevice } from "./style/useDevice";
import { concatClassnames } from "./util";

export const useDeviceClassNames = (isMobile?: boolean) => {
  const { isMobile: _isMobile, isIframe } = useDevice();

  if (isMobile === undefined) {
    isMobile = _isMobile;
  }

  return concatClassnames([
    !!isMobile && "cvp-mobile",
    !!isIframe && "cvp-iframe",
  ]);
};
